<script setup lang="ts">
import { computed } from "vue";
import IncidentIcon from "@component/IncidentIcon.vue";
import IncidentLevel from "@dashboard/base/IncidentLevel";
import type { IncidentAlertsMap } from "@entity/Incident";
import type { ServiceRowProps } from "@entity/ServiceRow";

defineOptions({
  inheritAttrs: false,
});

interface Props extends ServiceRowProps {
  text: string;
  regionNames: string[];
}

interface GroupedRowIcon {
  id: number;
  level: string;
  alerts: IncidentAlertsMap;
  region: string;
}

const props = withDefaults(defineProps<Props>(), {
  text: "",
  service: "",
  report: () => [],
  ids: () => [],
  link: "",
  regionNames: () => [],
});

const icons = computed<Array<GroupedRowIcon | null>>(() =>
  props.regionNames.map((region, index) => {
    const id = props.ids[index];
    const reportItem = id === undefined ? undefined : props.report[id];

    if (id === undefined || !reportItem || !region) {
      return null;
    }

    return {
      id,
      level: reportItem.level ?? IncidentLevel.Good,
      alerts: reportItem.alerts ?? {},
      region: region.toLowerCase(),
    };
  }),
);
const hasReport = computed(() => icons.value.some((icon) => icon !== null));
</script>

<template>
  <div class="inner-block">
    <p class="inner-label">{{ props.text }}</p>
    <div v-if="hasReport" class="inner-warnings">
      <template v-for="(icon, index) in icons" :key="props.regionNames[index]">
        <IncidentIcon
          v-if="icon"
          :service="props.service"
          :level="icon.level"
          :alerts="icon.alerts"
          :region="icon.region"
        />
        <div v-else class="have-info-wrapper left large" aria-hidden="true" />
      </template>
    </div>
  </div>
</template>
